import React, { createContext, useCallback, useContext, useState } from "react";

const DataContext = createContext();
const DataProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const storedData = sessionStorage.getItem("data");
    return storedData ? JSON.parse(storedData) : {};
  });

  const changeData = useCallback(
    (newData) =>
      setData((prevData) => {
        const updatedData = { ...prevData, ...newData };
        sessionStorage.setItem("data", JSON.stringify(updatedData)); // Update session storage
        return updatedData;
      }),
    []
  );

  return (
    <DataContext.Provider value={{ data, changeData }}>
      {children}
    </DataContext.Provider>
  );
};

const useData = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};

export { DataProvider, useData };
